module.exports = __webpack_public_path__ + "img/card-prov-remedy-req-management-hover.d5830a2e.svg";